module.exports = __webpack_public_path__ + "img/convert-arrows-icon.75ef9f94.svg";